import { render } from "./job.vue?vue&type=template&id=2816cb41&scoped=true"
import script from "./job.vue?vue&type=script&lang=js"
export * from "./job.vue?vue&type=script&lang=js"

import "./job.vue?vue&type=style&index=0&id=2816cb41&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2816cb41"],['__file',"src/js/components/job.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2816cb41"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2816cb41', __exports__)) {
    api.reload('2816cb41', __exports__)
  }
  
  module.hot.accept("./job.vue?vue&type=template&id=2816cb41&scoped=true", () => {
    api.rerender('2816cb41', render)
  })

}


export default __exports__